'use strict';

/* jshint -W098 */
angular.module('mean.holidays').controller('HolidaysController', ['$scope', 'Global', 'Holidays', '$filter', 'MeanUser', 'userService', 'toaster',
  function($scope, Global, Holidays, $filter, MeanUser, userService, toaster) {
    $scope.global = Global;
    $scope.package = {
      name: 'holidays'
    };

    $scope.user = MeanUser.user;

    /*
    holding this here for now
    $http({
		url: '/hola',
		skipAuthorization: true
		method: 'GET'
		});
	*/

    $scope.years = ['2015', '2016', '2017', '2018', '2019', '2020'];
    var dateFormat = 'yyyy-MM-dd';

    $scope.minDate = new Date();

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 0,
        showWeeks: false
    };

    $scope.init = function() {
        console.log('in the init function');
        userService.getMainAccount($scope.user.username).then(function(main_user) {
            Holidays.query({'main_account_id': main_user._id }, function(holidays) {
                if(holidays.length === 0) {
                    var my_holidays = new Holidays({
                        'main_account_id': main_user._id,
                        'trade': $scope.user.trade[0],
                        'company_code': $scope.user.contractor_code
                    });

                    my_holidays.$save(function(success) {
                        $scope.holidays = success;
                        toaster.pop('success', 'Holidays Database', 'Created Successfully.');
                    }, function(error) {
                        toaster.pop('error', 'Holidays Database Error', error);
                    });
                } else if(holidays.length === 1) {
                    $scope.holidays = holidays[0];
                } else {
                    toaster.pop('error', 'Holidays Database Error', 'Contact Admin');
                    return;
                }
            });
        });
    };

    // Disable weekend selection
	$scope.disabled = function(date, mode) {
		if(mode === 'day') {
			var dates = [];
			$scope.holidays.forEach(function(day) {
				dates.push($filter('date')(day.date, dateFormat));
			});

			if(dates.indexOf($filter('date')(date, dateFormat)) !== -1) {
				return 1;
			}
		}
		return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
	};

    $scope.add = function() {
    	if($scope.selectedItem.name && $scope.selectedItem.date) {
    		$scope.holidays.entries.push({
    			name: $scope.selectedItem.name,
    			date: $scope.selectedItem.date
    		});

    		$scope.holidays.$update(function(success) {
                toaster.pop('success', 'Holidays Updated', 'Added New Entry');
                $scope.selectedItem.name =
                $scope.selectedItem.date = '';
            }, function(error) {
                toaster.pop('error', 'Holidays Update Error', error);
            });
    	}
    };

    $scope.open = function($event) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened = true;
    };

    $scope.removeDate = function(holiday) {
    	var index = $scope.holidays.entries.indexOf(holiday);
  		$scope.holidays.entries.splice(index, 1);
  		$scope.holidays.$update(function(success) {
            toaster.pop('success', 'Holidays Updated', 'Entry Removed');
            $scope.selectedItem.name =
            $scope.selectedItem.date = '';
        }, function(error) {
            toaster.pop('error', 'Holiday Delete Error', error);
        });
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/holidays/public/controllers/holidays.js